module.exports = __webpack_public_path__ + "4d23e9d80b9a7e50107acff8b807fda5.svg";